import useActiveItem from "hooks/useActiveItem";
import { useLocation } from "react-router-dom";
import ActiveItemDetails from "./ActiveItemDetails";
import ActiveItemProperties from "./ActiveItemProperties";
import ActiveItemOpenSell from "./ActiveItemOpenSell";
import ActiveItemMarketplaceButton from "./ActiveItemMarketplaceButton";
import ActiveItemCommonButtons from "./ActiveItemCommonButtons";
import ActiveItemIdentityCraftSelect from "./ActiveItemIdentityCraftSelect";
import ActiveItemIPredictionCraftSelect from "./ActiveItemIPredictionCraftSelect";
import ActiveItemContents from "./ActiveItemContents";
import ActiveItemPrice from "./ActiveItemPrice";

const ActiveItem = ({ parentSwiper = null }) => {
  const { pathname } = useLocation();
  const { activeItem } = useActiveItem();

  if (!activeItem) {
    return null;
  }

  const {
    name,
    image,
    type,
    properties,
    pack_type,
    tag,
    cost,
    owned_by_self,
    is_listed,
    id,
    pack_contents,
  } = activeItem;

  return (
    <section className="card-details">
      <ActiveItemDetails
        pathname={pathname}
        name={name}
        img={image}
        type={type}
        properties={properties}
        packType={pack_type}
        tag={tag}
        cost={cost}
        isMine={owned_by_self}
      />

      <ActiveItemProperties properties={properties} />


      {pathname.includes("inventory/card-packs") &&
        !pathname.includes("inventory/card-pack-open") && (
          <ActiveItemOpenSell is_listed={is_listed} id={id} />
        )}

      {pathname.includes("/marketplace") && (
        <ActiveItemMarketplaceButton
          tag={tag}
          isListed={is_listed}
          isMine={owned_by_self}
        />
      )}

      {!pathname.includes("/card-pack-open") && (
        <ActiveItemCommonButtons pathname={pathname} isListed={is_listed} />
      )}

      {pathname.includes("/crafting/identity") && (
        <ActiveItemIdentityCraftSelect item={activeItem} />
      )}

      {pathname.includes("/crafting/prediction") && (
        <ActiveItemIPredictionCraftSelect item={activeItem} />
      )}

      {pack_contents && (
        <ActiveItemContents
          parentSwiper={parentSwiper}
          contents={pack_contents}
        />
      )}

      {pathname === "/buypacks" && <ActiveItemPrice />}
    </section>
  );
};

export default ActiveItem;
